module.exports = __webpack_public_path__ + "static/img/file-invoice.d6ac557c.svg";